import { render, staticRenderFns } from "./LifelineListView.vue?vue&type=template&id=39becc3a&scoped=true"
import script from "./LifelineListView.vue?vue&type=script&lang=js"
export * from "./LifelineListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39becc3a",
  null
  
)

export default component.exports